import { render, staticRenderFns } from "./manage-medical-groups-page.vue?vue&type=template&id=9cd4b7a4&scoped=true"
import script from "./manage-medical-groups-page.vue?vue&type=script&lang=js"
export * from "./manage-medical-groups-page.vue?vue&type=script&lang=js"
import style0 from "./manage-medical-groups-page.vue?vue&type=style&index=0&id=9cd4b7a4&prod&scoped=true&lang=css"
import style1 from "./manage-medical-groups-page.vue?vue&type=style&index=1&id=9cd4b7a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd4b7a4",
  null
  
)

export default component.exports